import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { StudentCommentDetailComponent } from './student-comment-detail.component';
import { StudentCommentPopupComponent } from './student-comment-dialog.component';
import { StudentCommentDeletePopupComponent } from './student-comment-delete-dialog.component';

export const StudentCommentRoute: Routes = [
    {
        path: 'student-comment/:id',
        component: StudentCommentDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.StudentComment.home.title'
        }
    }
];

export const StudentCommentPopupRoute: Routes = [
    {
        path: 'student-comment-new',
        component: StudentCommentPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.StudentComment.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'student-comment-new-for-student/:studentId',
        component: StudentCommentPopupComponent,
        data: {
            authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
            pageTitle: 'jYoguiApp.studentComment.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'student-comment/:id/edit',
        component: StudentCommentPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.StudentComment.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'student-comment/:id/delete',
        component: StudentCommentDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.StudentComment.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student-comment/student-comment.route.ts